import React from "react";

import {
  Input,
  Button,
  Space,
  Checkbox,
  Pagination,
  Row,
  Col,
  Empty,
  Spin,
  message,
} from "antd";
import { connect } from "react-redux";

import {
  DeleteOutlined,
  PictureOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

import { RootState, RootDispatch } from "store";

import ImageList from "components/imagemanager/imagelist";
import FolderTree from "components/imagemanager/foldertree";
import ModalCreateDir from "components/imagemanager/modal/createdir";
import ModalImgUploader from "components/imagemanager/modal/imguploader";
// import FolderList from "components/imagemanager/folderlist";
import "./imageManager.scss";

const { Search } = Input;

const mapState = (state: RootState) => ({
  folders: state.imagemanager.folders,
  currentFolderId: state.imagemanager.currentFolderId,
  resources: state.imagemanager.resources,
  uploadToken: state.imagemanager.uploadToken,
  loading: state.loading.global,
  // resources: state.imagemanager.resources,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  getFoldersAsync: () => dispatch.imagemanager.getFoldersAsync(),
  createDirAsync: (data) => dispatch.imagemanager.createDirAsync(data),
  getFolderCountAsync: (folderName) =>
    dispatch.imagemanager.getFolderCountAsync(folderName),
  deleteFolderAsync: (id) => dispatch.imagemanager.deleteFolderAsync(id),
  getQiniuUploadToken: () => dispatch.imagemanager.getQiniuUploadToken(),
  checkResourceExsited: (resourceName) =>
    dispatch.imagemanager.checkResourceExisted(resourceName),
  addResource: (resource) => dispatch.imagemanager.addResource(resource),
  removeResource: (index) => dispatch.imagemanager.removeResource(index),
  getResourcesAsync: (data) => dispatch.imagemanager.getResourcesAsync(data),
  removeResourceAsync: (data) =>
    dispatch.imagemanager.removeResourceAsync(data),
  searchResourceAsync: (data) =>
    dispatch.imagemanager.searchResourcesAsync(data),
  searchFoldersAsync: (data) => dispatch.imagemanager.searchFoldersAsync(data),
  // createDir: (node) => dispatch.imagemanager.createDir,
});

type connectedProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;
type Props = connectedProps;

export class ImageManager extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handleCreateDirModalShow = this.handleCreateDirModalShow.bind(this);
    this.onModalCreateDirConfirm = this.onModalCreateDirConfirm.bind(this);
    this.onModalCreateDirCancel = this.onModalCreateDirCancel.bind(this);
    this.handleDeleteFolder = this.handleDeleteFolder.bind(this);
    this.handleCheckboxGroupChange = this.handleCheckboxGroupChange.bind(this);
    this.onAllCheckedChange = this.onAllCheckedChange.bind(this);
    this.clearChecked = this.clearChecked.bind(this);
    this.onBtnImgUploadClick = this.onBtnImgUploadClick.bind(this);
    this.onHideModalImgUploader = this.onHideModalImgUploader.bind(this);
    this.onBtnRemoveResourcesClick = this.onBtnRemoveResourcesClick.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onTreeFoldersSelect = this.onTreeFoldersSelect.bind(this);
    this.onResourceSearch = this.onResourceSearch.bind(this);
    this.onSearchFolder = this.onSearchFolder.bind(this);
  }

  state = {
    isCreateDirModalShow: false,
    selectedNode: {} as any,
    selectedFolderByLeft: {} as any,
    checkedIds: [],
    searchedFolders: [],
    isModalImgUploaderShow: false,
    // 点击左边目录树时切换到list,点击搜索按钮时切换到search
    fetchResourceMode: "list",
    searchResourceKeyword: null,
    searchFolderKeyword: null,
  };

  componentDidMount() {
    // 禁用滚动条
    // document.body.style.overflow = "hidden";
    const {
      getFoldersAsync,
      getQiniuUploadToken,
      // getResourcesAsync,
    } = this.props;
    getFoldersAsync();
    // getResourcesAsync({ offset: 0, limit: 20 });
    getQiniuUploadToken();
    // this.props.createDirAsync()
  }

  onModalCreateDirConfirm() {
    this.props.getFoldersAsync();
    this.setState({ isCreateDirModalShow: false });
  }

  onModalCreateDirCancel() {
    this.setState({ isCreateDirModalShow: false });
  }

  handleCreateDirModalShow(node: any) {
    this.setState({ isCreateDirModalShow: true, selectedNode: node });
  }

  handleDeleteFolder(id) {
    this.props.deleteFolderAsync(id).then((res: any) => {
      console.log(res);
      if (res.msg === "操作成功") this.props.getFoldersAsync();
    });
  }

  handleCheckboxGroupChange(checkedIds) {
    this.setState({
      checkedIds,
    });
  }

  onAllCheckedChange(e) {
    // console.log(e);
    const {
      target: { checked },
    } = e;
    if (!checked) {
      this.setState({
        checkedIds: [],
      });
      return false;
    }
    const {
      resources: { list },
    } = this.props;
    const checkedIds = list.map((item) => item.id);
    this.setState({
      checkedIds,
    });
  }

  // ! deprecated
  clearChecked() {
    this.setState({ checkedIds: [] });
  }

  onBtnImgUploadClick() {
    this.setState({
      isModalImgUploaderShow: true,
    });
  }

  onHideModalImgUploader() {
    this.setState({
      isModalImgUploaderShow: false,
    });
  }

  onPaginationChange(page, pageSize) {
    console.log(page, pageSize);
    const { getResourcesAsync } = this.props;
    const {
      selectedFolderByLeft,
      searchResourceKeyword,
      fetchResourceMode,
    } = this.state;
    // console.log(selectedFolderByLeft);
    getResourcesAsync({
      pageNum: page,
      pageSize: pageSize,
      fid: fetchResourceMode === "list" ? selectedFolderByLeft.id : null,
      name: fetchResourceMode === "search" ? searchResourceKeyword : undefined,
    });
  }

  onTreeFoldersSelect(selectedFolder) {
    const { getResourcesAsync } = this.props;
    // console.log(selectedFolder);
    getResourcesAsync({ fid: selectedFolder.id, pageSize: 40, pageNum: 1 });
    // this.clearChecked();
    this.setState({
      selectedFolderByLeft: selectedFolder,
      checkedIds: [],
      fetchResourceMode: "list",
    });
  }

  onResourceSearch(value) {
    if (!value) {
      message.error("请输入图片的关键字进行查询");
      return;
    }
    // this.props
    //   .searchResourceAsync({ resourceName: value, pageSize: 140, pageNum: 1 })
    //   .then((res) => {
    //     console.log(res);
    //   });
    // const { selectedFolderByLeft } = this.state;
    // console.log(selectedFolderByLeft)
    this.props
      .getResourcesAsync({
        name: value,
        pageNum: 1,
        pageSize: 40,
      })
      .then((res) => {
        this.setState({
          searchKeywords: value,
          fetchResourceMode: "search",
        });
      });
  }

  onSearchFolder(name: string) {
    if (!name) {
      this.setState({ searchedFolders: [] });
      return;
    }
    this.props.searchFoldersAsync({ name: name }).then((res: any) => {
      console.log(res);
      this.setState({
        searchedFolders: res.data,
      });
    });
  }

  onBtnRemoveResourcesClick() {}

  render() {
    const {
      folders,
      uploadToken,
      resources,
      currentFolderId,
      loading,
    } = this.props;
    const {
      createDirAsync,
      getFolderCountAsync,
      checkResourceExsited,
      addResource,
      removeResource,
      removeResourceAsync,
      getResourcesAsync,
    } = this.props;
    const { list, total, pageNum, pageSize } = resources;
    const {
      selectedNode,
      isCreateDirModalShow,
      isModalImgUploaderShow,
      checkedIds,
      searchResourceKeyword,
      fetchResourceMode,
      searchedFolders,
    } = this.state;
    const isAllChecked =
      list.length === 0 ? false : list.length === checkedIds.length;
    // console.log(currentFolderId);
    return (
      <div className="image-manager-layout">
        <div className="layout-container-left">
          <FolderTree
            treeData={folders}
            // resources={resources}
            searchedFolders={searchedFolders}
            currentFolderId={currentFolderId}
            onSearchFolder={this.onSearchFolder}
            onDeleteFolder={this.handleDeleteFolder}
            onTreeSelect={this.onTreeFoldersSelect}
            onCreateDirModalShow={this.handleCreateDirModalShow}
          />
        </div>
        <div className="layout-container-right">
          <Space size="large">
            <Space>
              <Checkbox
                onChange={this.onAllCheckedChange}
                checked={isAllChecked}
                disabled={list.length === 0}
              >
                全选
              </Checkbox>
              <span>
                已选中
                <span style={{ color: "#ff9900" }}>{checkedIds.length}</span>/
                {list.length}
              </span>
            </Space>
            {/* <Space style={{ marginLeft: 30 }}>
              <Button
                onClick={this.onBtnRemoveResourcesClick}
                icon={<DeleteOutlined />}
              >
                删除
              </Button>
            </Space> */}
            <Space>
              <Button
                onClick={this.onBtnImgUploadClick}
                icon={<PictureOutlined />}
              >
                上传资源
              </Button>
              {/* <Button icon={<VideoCameraOutlined />}>上传视频</Button> */}
              {/* <Button icon={<PlusOutlined />}>新建文件夹</Button> */}
              {/* <Input />
            <Button>搜索</Button> */}
              <Search
                placeholder="搜索文件来这里"
                onSearch={this.onResourceSearch}
                enterButton
                style={{ width: 350 }}
              />
            </Space>
          </Space>
          <div>
            <Spin
              spinning={loading}
              size="large"
              tip="loading..."
              delay={1}
              className="resource-list-indicator"
            >
              <div className="resource-list-container">
                {list.length > 0 && (
                  <ImageList
                    searchKeyword={
                      fetchResourceMode === "search"
                        ? searchResourceKeyword
                        : null
                    }
                    checkedIds={checkedIds}
                    data={resources}
                    onCheckboxGroupChange={this.handleCheckboxGroupChange}
                    onRemoveResourceAsync={removeResourceAsync}
                    onRemoveResource={removeResource}
                  />
                )}

                <div className="empty-wrapper">
                  {list.length === 0 && <Empty description="暂无数据" />}
                </div>
              </div>
            </Spin>
          </div>
          {total > 0 && (
            <Row className="pagination-wrapper">
              <Pagination
                total={total}
                current={pageNum}
                pageSize={pageSize}
                showSizeChanger={false}
                // showQuickJumper
                onChange={this.onPaginationChange}
                showTotal={(total) => `总共 ${total} 个`}
              />
            </Row>
          )}
        </div>
        <ModalCreateDir
          onCancel={this.onModalCreateDirCancel}
          onOK={this.onModalCreateDirConfirm}
          onCreateDir={createDirAsync}
          onFolderNameCheck={getFolderCountAsync}
          visible={isCreateDirModalShow}
          treeData={folders}
          parentFolder={selectedNode}
        />
        <ModalImgUploader
          visible={isModalImgUploaderShow}
          treeData={folders}
          onAddResource={addResource}
          onCancel={this.onHideModalImgUploader}
          onOK={this.onHideModalImgUploader}
          onRemoveResource={removeResource}
          onCheckResourceUnique={checkResourceExsited}
          token={uploadToken}
        />
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(ImageManager);
